module.exports = __webpack_public_path__ + "img/partner9.858fd087.jpg";